import { useMemo, useState, useCallback } from "react";
import { matchesWithWildcard } from "../util/helper/helperFunctions";

const useTableSearch = (data) => {
  const [searchFilters, setSearchFilters] = useState({});

  const updateFilter = useCallback((key, value) => {
    setSearchFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  }, []);

  const clearFilters = useCallback(() => {
    setSearchFilters({});
  }, []);

  const filteredData = useMemo(() => {
    if (!data?.length) return [];

    return data.filter((item) =>
      Object.entries(searchFilters).every(([key, value]) => {
        if (!value) return true;
        const cellValue = String(item[key] ?? "").toLowerCase();
        return matchesWithWildcard(value, cellValue);
      })
    );
  }, [data, searchFilters]);

  return {
    filteredData,
    searchFilters,
    updateFilter,
    clearFilters,
  };
};

export default useTableSearch;
